module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_null.44273a0f.png";